module.exports = __webpack_public_path__ + "img/form-success.1243dfc1.svg";